<template>
  <div class="go-comment">
    <h2 class="title">评价订单</h2>
    <div class="comment-item">
      <div class="product-info">
        <img :src="commentList.newImg" class="product-img" />
        <div class="product-text">
          <div class="product-name">{{ commentList.goodsName }}</div>
          <div class="product-desc">{{ commentList.specificationValue }}</div>
        </div>
      </div>
      <div class="comment-content">
        <div class="rate-row">
          <span>商品评价</span>
          <el-rate v-model="form.stars" allow-half></el-rate>
        </div>
        <div class="input-row">
          <span>填写评价内容</span>
          <el-input type="textarea" :rows="3" maxlength="200" show-word-limit placeholder="请输入您的使用体验..."
            v-model="form.content"></el-input>
        </div>
        <div class="upload-row">
          <span>上传图片<br /><small>(最多三张)</small></span>
          <el-upload class="upload-demo" action="#" :limit="3" :file-list="fileList"
            :on-remove="(file, fileList) => handleRemove(file, fileList)"
            :on-change="(file, fileList) => handleChange(file, fileList)" list-type="picture-card" :auto-upload="false">
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
      </div>
    </div>
    <div class="submit-btn">
      <el-button type="success" @click="handleSubmit">发表</el-button>
    </div>
  </div>
</template>

<script>

import { commitCreate } from '@/api/sjzx'
import { uploadFile } from "@/api/fileApi";
export default {
  data() {
    return {
      commentList: {},
      // query: {
      //   pageNum: 1,
      //   pageSize: 10,
      // },
      form: {
        stars: 0,//星级
        content: '',//评价
        img: [

        ],
      },
      fileList: [],//图片
    }
  },
  mounted() {
    // console.log(this.$route.query.goodsId, '查看这个id是多少')
    this.getCommentlist()
  },
  methods: {
    async getCommentlist() {
      this.commentList = this.$route.query.shopDetail
      console.log(this.commentList, '查看this.commentList')

    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      const url = file.url || (file.response && file.response.url);
      const name = file.name;
      if (Array.isArray(this.form.img)) {
        this.form.img = this.form.img.filter(imgObj => imgObj.url !== url && imgObj.name !== name);
      }
    },
    async handleChange(file, fileList) {
      this.fileList = fileList;
      if (file.status === 'ready') {
        const formData = new FormData();
        formData.append('file', file.raw);
        const res = await uploadFile(formData);
        if (res.code === 0 && res.data) {
          let { url, sourceFileName
          } = res.data
          if (!Array.isArray(this.form.img)) {
            this.form.img = [];
          }
          this.form.img.push({
            name: sourceFileName,
            url: url
          });
        } else {
          this.$message.error('图片上传失败');
        }
      }
    },
    async handleSubmit() {
      // let params = this.commentList.map(item => item.productId)
      // let productIds = []
      // productIds.push(this.commentList.productId)
      
      const params = {
        stars: this.form.stars,
        content: this.form.content,
        productIds:[this.commentList.productId],
        orderId: this.commentList.orderItemId,
        img: JSON.stringify(this.form.img),
      };
      // console.log(params, '查看params');
      const res = await commitCreate(params);
      if (res.code === 0) {
        this.$message.success('评价已提交！');
        this.$router.back()
      } else {
        this.$message.error(res.msg || '提交失败');
      }
    },
  },
}
</script>

<style scoped>
.go-comment {
  background: #fafbfc;
  min-height: 100vh;
  padding: 20px 0 40px 0;
}

.title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 20px;
  margin-left: 20px;
}

.comment-item {
  background: #fff;
  margin: 20px auto;
  padding: 24px 32px;
  border-radius: 8px;
  max-width: 900px;
  display: flex;
  align-items: flex-start;
}

.product-info {
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.product-img {
  width: 60px;
  height: 60px;
  margin-bottom: 12px;
  border-radius: 8px;
  object-fit: cover;
  background: #f5f5f5;
}

.product-text {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.product-name {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 4px;
}

.product-desc {
  color: #888;
  font-size: 13px;
}

.comment-content {
  flex: 1;
  margin-left: 40px;
}

.rate-row,
.input-row,
.upload-row {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.rate-row span,
.input-row span,
.upload-row span {
  width: 90px;
  color: #333;
  font-size: 14px;
}

.input-row span {
  width: 90px;
  color: #333;
  font-size: 14px;
  white-space: nowrap;
}

.upload-row small {
  color: #aaa;
  font-size: 12px;
}

.submit-btn {
  text-align: center;
  margin-top: 30px;
  background-color: white;
}
</style>
